'use client';

import ActivityProductGrid from '@/app/(activity)/components/ActivityProductGrid';
import { EPlatform } from '@/utils/enums/platform-enum';

interface SparklyMightLikeProps {
  might_like_title?: string;
  might_like_group_id?: string;
  deviceType: EPlatform;
  onProductExp: (sensorData: {
    item: any;
    index: number;
    module_name: string;
    image_type: string;
  }) => void;
  onProductClick: (sensorData: {
    item: any;
    index: number;
    module_name: string;
    image_type: string;
  }) => void;
}

export default function SparklyMightLike({
  might_like_title,
  might_like_group_id,
  deviceType,
  onProductExp,
  onProductClick,
}: SparklyMightLikeProps) {
  // 如果没有group_id，不显示组件
  if (!might_like_group_id) {
    return null;
  }

  // 处理商品点击
  const handleProductClick = (product: any, index: number) => {
    onProductClick({
      item: product,
      index,
      module_name: '卖货版位',
      image_type: '商品图',
    });
  };

  // 处理商品曝光
  const handleProductExp = (product: any, index: number) => {
    onProductExp({
      item: product,
      index,
      module_name: '卖货版位',
      image_type: '商品图',
    });
  };

  return (
    <div className="bg-white font-regular">
      <ActivityProductGrid
        title={might_like_title}
        deviceType={deviceType}
        apiConfig={{
          group_id: parseInt(might_like_group_id, 10),
          limit: 120, // 推荐商品数量限制
        }}
        showInfiniteScroll
        wapColumns={2}
        pcColumns={{ lg: 2, xl: 3, '2xl': 4 }}
        padding={{
          wap: 'px-[8px]',
          pc: 'px-[48px]',
        }}
        productCardProps={{
          showTryOn: false,
          showCorrelation: false,
          className: 'bg-none',
          imageClassName: deviceType !== EPlatform.WEB ? 'h-[176px] rounded-[12px]' : undefined,
        }}
        onProductClick={handleProductClick}
        onProductExp={handleProductExp}
        className={`${deviceType !== EPlatform.WEB ? 'pt-[24px]' : ''}`}
      />
    </div>
  );
}
